module.exports = __webpack_public_path__ + "media/images/players/CANTER_LAURIE-2de020624d6ac12652d7c0b0036d1711.png";